import { inject } from '@angular/core';
import {
	HttpRequest,
	HttpEvent,
	HttpHandlerFn,
	HttpContextToken
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../auth/services/auth.service';
import { Router } from '@angular/router';
import { environment } from '@env';
import { MessageService } from '../services/message.service';

export const SKIP_ERROR_TOKEN = new HttpContextToken<boolean>(() => false);

export const credentialsInterceptor = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
	const router = inject(Router);
	const authService = inject(AuthService);
	const notificationService = inject(MessageService);
	const newReq = req.url.includes(environment.apiUrl)
		? req.clone({
			withCredentials: true,
		})
		: req;
	return next(newReq).pipe(
		catchError(err => {
			if ([401, 403].includes(err.status) && authService.isAuthenticated()) {
				// auto logout if 401 or 403 response returned from api
				router.navigate(['/auth/login']);
			} else if (err) {
				const skipError = req.context.get(SKIP_ERROR_TOKEN);
				if (!skipError) {
					notificationService.showServerError(err);
				}
			}
			
			return throwError(() => err);
		})
	);
}
